export const noop = () => {};
export const returnNull = () => null;